module.exports = __webpack_public_path__ + "img/goleft.4b27697c.svg";